function injectStyle (ssrContext) {
  require("!!../../../../../../node_modules/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../../node_modules/_vue-loader@12.1.0@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-d1ff9c42\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../../../node_modules/_vue-loader@12.1.0@vue-loader/lib/selector?type=styles&index=0!./page.vue")
}
var Component = require("!../../../../../../node_modules/_vue-loader@12.1.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/_vue-loader@12.1.0@vue-loader/lib/selector?type=script&index=0!./page.vue"),
  /* template */
  require("!!../../../../../../node_modules/_vue-loader@12.1.0@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d1ff9c42\"}!../../../../../../node_modules/_vue-loader@12.1.0@vue-loader/lib/selector?type=template&index=0!./page.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/cms/user/user_center/src/page.vue
// module id = 378
// module chunks = 1